import { Button as SrButton } from "@starrez/starryui9";
import * as React from "react";
import { IButtonProps } from ".";
import { ButtonWrapperDiv } from "./Button.styles";

export const Button: React.FunctionComponent<IButtonProps> =
    (props: IButtonProps) => {
        return (
            <ButtonWrapperDiv showAsEnabled={props.showAsEnabled}>
                <SrButton {...props} />
            </ButtonWrapperDiv>
        );
    };
